import { render, staticRenderFns } from "./HeaderTemplate.vue?vue&type=template&id=4b8a6ce9&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&lang=js"
import style0 from "./HeaderTemplate.vue?vue&type=style&index=0&id=4b8a6ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a6ce9",
  null
  
)

export default component.exports